angular.module('acme.view.application.account.administration.emailLanguage.services',[
  'acme.common.service.calendar',
  'acme.common.service.api'
])
.service('EmailLanguagesService', [ '$http', '$q', '$timeout', 'ApiService', 'CalendarService', function($http, $q, $timeout, ApiService, HelpersService) {

  return {
    getList: function(props) {
      return ApiService.administration.languages.list(props);
    },

    getSelectedLanguages: function(props) {
      return ApiService.administration.languages.listCustom(props);
    },

    updateSelectedLanguages: function(items) {
      return ApiService.administration.languages.update(items);
    },

    checkSelectedLanguages: function(items) {
      var selectedLanguages = items.filter(function(item) {
        return item.selected;
      });
      return selectedLanguages;
    }
  };

}]);